var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoBjBust(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 19 19",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.875,
    cy: 9.068,
    r: 9,
    fill: "#E40000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.55 4.361q1.849 0 2.794.54.945.527.945 1.863 0 .567-.203 1.012a1.94 1.94 0 0 1-.594.73q-.378.282-.945.377v.068q.58.095 1.04.351.459.243.729.716.27.472.27 1.228 0 .878-.419 1.499-.405.607-1.174.931-.756.324-1.81.324H6.729V4.361zm.242 4.023q1.134 0 1.553-.365.432-.364.432-1.08 0-.729-.513-1.039T9.63 5.59H8.186v2.794zM8.186 9.572v3.213h1.768q1.175 0 1.634-.459t.459-1.215q0-.459-.203-.81-.202-.351-.688-.54-.473-.189-1.296-.189z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBjBust);
export default __webpack_public_path__ + "static/media/IcoBJBust.ef60ef9af3c5adf24731c646d641b83a.svg";
export { ForwardRef as ReactComponent };